var resizeElementHeight = function(container, screenHeight) {
  var height = 0;
  screenHeight = screenHeight || null;
  if( container ) {
    var content = container;
    height = (window.innerHeight - container.offsetTop);
    content.style.height = parseInt(height) + 'px';
  }
}

export default resizeElementHeight